<template>
  <v-card 
  light
  style="padding: 30px 30px; height: 100%;"
  >
  <v-btn 
  small 
  icon 
  style="width: 30px; height: 30px; position: absolute; top: 10px; right: 10px;"
  @click="closeLog"
  >
    <img src="@/assets/close.svg">
  </v-btn>
    <div class="d-flex justify-left align-center" style="width: 100%;">
        <img style="width: 40px;" src="@/assets/history.svg">
        <v-card-title class="text-h4 font-weight-medium">User Log</v-card-title>
    </div>
    <v-data-table
    fixed-header
      height="75%"
      :headers="header"
      :items="arrangedData"
      sort-by="time"
      :sort-desc="true"
      class="elevation-0"
      :search="search"  
      id="tableWrap"
      >
      
      <template v-slot:top>
        <v-toolbar flat>
            <div :style="$vuetify.breakpoint.width>600? 'width: 50%;':'width: 100%;'" id="searchWrap">
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                hide-details
                dense
                solo
                color="currentColor"
              ></v-text-field>
            </div>

          </v-toolbar>

        </template>
      </v-data-table>
  </v-card>
</template>

<script>
import EventBus from '@/plugins/EventBus'

export default {
  name: 'userLog',
  data:()=>{
    return {
      header:[
        { text: "Date", value: "time", align: "center" },
        { text: "Name", value: "username", align: "center" },
        { text: "Action", value: "action", align: "left" },
        { text: "Details", value: "details", align: "left" },
      ],
      arrangedData:[],
      search:null
    }
  },
  props:{
    logData: Array
  },
  created(){
    this.arrangedData = this.logData.map((x)=>{
      return{
        username: x.user.username,
        time: this.formatDate(x.time),
        action: x.action,
        details: x.additional_data
      }
    })
    // console.log("this.arrangedData")
    // console.log(this.arrangedData)
  },
  methods:{
    formatDate(isoStr) {
      const date = new Date(isoStr);

      const yyyy = date.getFullYear();
      const mm = String(date.getMonth() + 1).padStart(2, '0'); // 0-based
      const dd = String(date.getDate()).padStart(2, '0');
      const hh = String(date.getHours()).padStart(2, '0');
      const min = String(date.getMinutes()).padStart(2, '0');
      const sec = String(date.getSeconds()).padStart(2, '0');

      return `${yyyy}.${mm}.${dd} ${hh}:${min}:${sec}`;
    },
    closeLog:function(){
      EventBus.$emit('closeLog')
    }

  }
}
</script>

<style>
#searchWrap .v-input{
  padding: 2px !important;
  margin-top: 0px !important;
}

#searchWrap .v-input__slot{
  background-color: #ECEFF1;
  box-shadow: none !important;
  border: 1px solid #CFD8DC;
  border-radius: 10px;
}

 #searchWrap #input-82{
  font-weight: 400 !important;
 }

#tableWrap{
  height: 90% !important;
}

#tableWrap .v-toolbar__content{
  padding: 0px !important;
}
 
 #tableWrap .v-data-table__wrapper{
  border: 1.2px solid #EEEEEE;
  border-radius: 10px;
  scrollbar-width: none;
 }
#tableWrap .v-data-table__wrapper::-webkit-scrollbar{
  display: none;
 }

#tableWrap th{
  background-color: #ECEFF1 !important;
  height: fit-content;
  padding: 10px;
}

#tableWrap .v-data-footer{
  border-top: transparent !important;
}
</style>